<template>
<div class="mcontainer">
  <van-nav-bar fixed title="查询咨询信息" left-text="返回" left-arrow @click-left="$utils.back()" />
  <div class="main__body">
    <div class="search__wrapper">
      <van-cell-group title="查询">
        <van-field v-model="code" label="输入代码：" placeholder="请输入查询代码" />
      </van-cell-group>
      <div class="btn__wrapper">
        <van-button type="info" size="large" @click="search">查询</van-button>
      </div>
    </div>
    <div class="input__wrapper" v-if="detail!=null">
      <van-cell-group title="咨询信息">
        <van-field v-model="detail.name"  readonly label="姓名：" placeholder="姓名" />
        <van-field v-model="detail.contact" readonly type="number" label="联系方式：" placeholder="联系方式" />
        <van-field v-model="detail.title"  readonly label="标题：" placeholder="标题" />
        <van-field v-model="detail.ask"  readonly label="咨询内容：" placeholder="咨询内容" type="textarea" autosize rows="1"/>
      </van-cell-group>
      <van-cell-group title="解答结果">
        <van-field v-model="detail.status_name" label="处理状态：" readonly />
        <van-field v-model="detail.ans" type="textarea" label="解答内容：" autosize readonly />
      </van-cell-group>
    </div>
  </div>
</div>
</template>
<script>
import {
  mapActions
} from 'vuex'
export default {
  components: {},
  data() {
    return {
      detail:null,
      code:''
    }
  },
  props: [],
  computed: {
    from(){
      return this.$route.query.from
    }
  },
  watch: {},
  created() {
  },
  mounted() {},
  destroyed() {},
  methods: {
    search(){
      if($.trim(this.code)==''){
        this.$utils.toast('请填写完整', 'err')
        return false
      }
      this.searchAsk()
    },
    async searchAsk() {
      let {
        code
      } = this
      let posData = {
        data: {
          code
        }
      }
      let res = await this._searchAsk(posData)
      if (res && res.code == 200) {
        let resData = res.data
        this.detail = resData
      }else{
        this.detail=null
      }
    },
    ...mapActions('api', ['_searchAsk'])
  }
}
</script>
<style lang="less" scoped>
.mcontainer {
    .main__body {
        margin-top: 46px;
    }
}
</style>
